import {
  Box,
  Flex,
  Input,
  Select,
  Spacer,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { Space, Spin, Table } from "antd";
import axios from "axios";
import { debounce, get } from "lodash";
import { useCallback, useEffect, useMemo, useState } from "react";
import {
  RiDeleteBin6Line,
  RiEditLine,
  RiStarFill,
  RiStarLine,
} from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import CasestudyEditDrawer from "../drawer/CasestudyEditDrawer";
import CasestudyDeleteConfirmation from "../modals/CasestudyDeleteConfirmation";
import CasestudyDetailsModal from "../modals/CasestudyDetailsModal";
import {
  SET_META_DATA_FOR_PAGINATION,
  SET_SEARCH_TEXT,
} from "../../store/casestudy/casestudyActionTypes";

interface Props {
  query: string;
}

const CasestudyTable: React.FC<Props> = ({ query }) => {
  const toast = useToast();
  const dispatch = useDispatch();
  const searchColumns = useMemo(() => ["title"], []);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [categoryNames, setCategoryNames] = useState<any[]>([]);
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [categoryFilter, setCategoryFilter] = useState<string>("All");
  const [casestudyData, setCasestudyData] = useState<any>();
  const [userDetail, setUserDetail] = useState<any>("");
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const metaData = useSelector((state: any) => state.casestudy.meta);
  // console.log("metaData", metaData);
  const searchText = useSelector((state: any) => state.casestudy.searchText);

  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    const fetchUserData = async () => {
      if (typeof window !== "undefined") {
        const userDataa = JSON.parse(localStorage.getItem("userDataa") || "{}");
        setUserDetail(userDataa);
      }
    };

    fetchUserData();
  }, []);

  const search = (casestudy: Record<string, any>) => {
    return searchColumns.some((column) => {
      return (
        get(casestudy, column, "")
          .toString()
          .toLowerCase()
          .indexOf(searchQuery.toLowerCase()) > -1
      );
    });
  };

  const [targetevent, setTargetEvent] = useState<any>();
  const [data, setData] = useState<any[]>([]);
  const [loading, setloading] = useState(true);

  const {
    isOpen: isViewOpen,
    onOpen: onViewOpen,
    onClose: onViewClose,
  } = useDisclosure();

  const {
    isOpen: isDeleteOpen,
    onOpen: onDeleteOpen,
    onClose: onDeleteClose,
  } = useDisclosure();

  const {
    isOpen: isUpdateOpen,
    onOpen: onUpdateOpen,
    onClose: onUpdateClose,
  } = useDisclosure();

  const {
    isOpen: isSlotDrawerOpen,
    onOpen: onSlotDrawerOpen,
    onClose: onSlotDrawerClose,
  } = useDisclosure();

  const handleSlotClick = (record: any) => {
    setTargetEvent(record);
    onSlotDrawerOpen();
  };
  const handleView = (record: any) => {
    setTargetEvent(record);
    onViewOpen();
  };

  const updateEvent = (record: any) => {
    setTargetEvent(record);
    onOpen();
  };

  const handleDelete = (record: any) => {
    setTargetEvent(record);
    onDeleteOpen();
  };
  useEffect(() => {
    const getCategoryNames = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/category/names`
        );

        setCategoryNames(["All", ...response.data]);
      } catch (error) {
        console.log(error);
      }
    };

    getCategoryNames();
  }, []);

  useEffect(() => {
    const metaLimit = Number(metaData?.limit) || 10;
    const page = Number(metaData?.page) || 1;

    let total = 0;
    if (metaData?.totalPages != null && !isNaN(metaData?.totalPages)) {
      total = Number(metaData?.totalPages) * metaLimit;
    } else {
      // totalPages unknown: allow one extra page if hasNextPage true
      if (metaData?.hasNextPage) {
        total = (page + 1) * metaLimit;
      } else {
        total = page * metaLimit;
      }
    }

    setPagination((p) => ({
      ...p,
      current: page,
      pageSize: metaLimit,
      total,
    }));
  }, [metaData]);

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    // setCategoryFilter(event.target.value);
    setPagination((p) => ({ ...p, current: 1 }));
    debouncedSearch(event.target.value);
    setSearchQuery("");
  };

  useEffect(() => {
    if (!categoryFilter) return;

    dispatch({
      type: "REQUEST_MASTER_CASESTUDY",
      payload: {
        type: categoryFilter,
        page: pagination.current,
        pageSize: pagination.pageSize,
        searchText: searchQuery || searchText,
      },

      onSuccess: (response: any) => {
        console.log("Fetched casestudy successfully:", response);
        dispatch({
          type: SET_META_DATA_FOR_PAGINATION,
          payload: response.meta,
        });

        const transformedData = response.data.map(
          (casestudy: any, index: number) => ({
            key: casestudy._id,
            index: index + 1,
            title: casestudy.title,
            image: `${process.env.REACT_APP_IMAGE_BASE_URL}/${casestudy.imageURL}`,
            casestudyId: casestudy.caseStydyId,
            createdDate: new Date(casestudy.createdAt).toLocaleDateString(),
            description: casestudy.description,
            subcategory: casestudy.subCategory,
            type: casestudy.type,
            url: `https://10turtle.com/work/${casestudy.titleUrl}`,
            // url: `https://10turtle.com/work/${casestudy.title
            //   .split(" ")
            //   .join("-")}?id=${casestudy.caseStydyId}`,
            isFav: casestudy.isFav,
            originalData: casestudy,
          })
        );
        // const filtered = searchQuery
        //   ? transformedData.filter(search)
        //   : transformedData;

        setFilteredData(transformedData);
        setloading(false);
      },
      onError: (error: any) => {
        console.error("Error fetching casestudy:", error);
        setloading(false);
        toast({
          title: "Error",
          description: "Failed to fetch case studies.",
          status: "error",
          duration: 3000,
          isClosable: true,
          position: "top-right",
        });
      },
    });
  }, [categoryFilter, searchQuery, pagination.current, searchText]);

  console.log("Search Query:", searchQuery);

  const debouncedSearch = useCallback(
    debounce((value: string) => {
      dispatch({
        type: SET_SEARCH_TEXT,
        payload: value,
      });
    }, 500), // 500ms delay
    [dispatch]
  );
  const handleSearch = (value: string) => {
    setPagination((p) => ({ ...p, current: 1 }));
    debouncedSearch(value);
    setSearchQuery(value);
  };

  const handleTableChange = (pag: any) => {
    // const q = searchText.trim().toLowerCase();
    // dispatch<any>(
    //   getServiceDetails(selectedLang, pag.current, pag.pageSize, q)
    // );
    console.log("Pagination changed:", pag);

    setPagination((p) => ({
      ...p,
      current: pag.current,
      pageSize: pag.pageSize,
    }));
  };
  console.log("pagination", pagination);
  console.log("metaDData", metaData);

  const SingleImage = ({ image }: { image: string }) => (
    <div
      style={{
        width: 36,
        height: 36,
        borderRadius: "50%",
        overflow: "hidden",
        backgroundColor: "white",
      }}
    >
      <img
        src={image}
        alt="Banner"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />
    </div>
  );

  const handleFavoriteToggle = async (record: any) => {
    console.log("record=-========", record);

    try {
      // Get the current record data
      const caseStudyData = await handleCasestudy(record);
      console.log("caseStudyData========", caseStudyData);

      let serviceIds = record?.originalData?.serviceId?.map(
        (service: any) => service._id || service
      );

      // Prepare the payload with all necessary fields
      const updatePayload: any = {
        caseStydyId: record.casestudyId,
        banner_title: record.title,
        banner_description: record.description,
        banner_type: record.type,
        banner_imageURL: record.originalData.imageURL,
        banner_subCategory: record.subcategory,
        serviceId: serviceIds || [],
        isFav: !record.isFav, // Toggle the favorite status
        // banner_titleUrl: record.url,
      };
      console.log("record.originalData.videoURL-----", record);
      // Add video URL if it exists
      if (
        record.originalData.videoURL &&
        record.originalData.videoURL.trim() !== ""
      ) {
        updatePayload.banner_videoURL = record.originalData.videoURL;
      }
      if (
        record.originalData.thumbUrl &&
        record.originalData.thumbUrl.trim() !== ""
      ) {
        updatePayload.banner_thumbUrl = record.originalData.thumbUrl;
      }
      console.log("updatePayload", updatePayload);

      // Make the API call to update the record
      const response = await axios({
        method: "patch",
        url: `${process.env.REACT_APP_BASE_URL}/admin/category/update/${record.originalData._id}`,
        data: updatePayload,
      });

      console.log("Favorite update response:", response);

      // Refresh the data
      // dispatch({ type: REQUEST_MASTER_CASESTUDY });
      dispatch({
        type: "REQUEST_MASTER_CASESTUDY",
        payload: {
          type: categoryFilter,
        },

        onSuccess: (response: any) => {
          console.log("Fetched casestudy successfully:", response);

          const transformedData = response.data.map(
            (casestudy: any, index: number) => ({
              key: casestudy._id,
              index: index + 1,
              title: casestudy.title,
              image: `${process.env.REACT_APP_IMAGE_BASE_URL}/${casestudy.imageURL}`,
              casestudyId: casestudy.caseStydyId,
              createdDate: new Date(casestudy.createdAt).toLocaleDateString(),
              description: casestudy.description,
              subcategory: casestudy.subCategory,
              type: casestudy.type,
              isFav: casestudy.isFav,
              originalData: casestudy,
              url: `https://10turtle.com/work/${casestudy.titleUrl}`,
            })
          );
          const filtered = searchQuery
            ? transformedData.filter(search)
            : transformedData;

          setFilteredData(filtered);
          setloading(false);
        },
        onError: (error: any) => {
          console.error("Error fetching casestudy:", error);
          setloading(false);
          toast({
            title: "Error",
            description: "Failed to fetch case studies.",
            status: "error",
            duration: 3000,
            isClosable: true,
            position: "top-right",
          });
        },
      });
      // Show success message
      toast({
        title: "Success",
        description: `Case study ${
          record.isFav ? "removed from" : "added to"
        } favorites`,
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
    } catch (error) {
      console.error("Error updating favorite status:", error);
      toast({
        title: "Error",
        description: "Failed to update favorite status",
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
    }
  };
  const columns = [
    {
      title: "Nos.",
      dataIndex: "index",
      width: 80,
      render: (_: any, __: any, index: number) => `#${index + 1}`,
    },
    {
      title: "Image",
      dataIndex: "image",
      width: 100,
      render: (image: string) => <SingleImage image={image} />,
    },
    {
      title: "Title",
      dataIndex: "title",
      width: 200,
    },
    {
      title: "Description",
      dataIndex: "description",
      width: 250,
    },
    {
      title: "Type",
      dataIndex: "type",
      width: 150,
    },
    {
      title: "Sub Category",
      dataIndex: "subcategory",
      width: 150,
    },
    {
      title: "Url",
      dataIndex: "url",
      render: (url: string) => (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#1890ff" }}
        >
          {url}
        </a>
      ),
      width: 150,
    },
    {
      title: "Created Date",
      dataIndex: "createdDate",
      width: 150,
    },
    {
      title: "Actions",
      key: "actions",
      width: 150,
      render: (_: any, record: any) => {
        // console.log("recordrecordrecordrecordrecord", record);

        return (
          <Space size="middle">
            <RiEditLine
              style={{
                color: "#000",
                cursor: "pointer",
                height: "20px",
                width: "20px",
              }}
              onClick={async () => {
                await handleCasestudy(record);
                setTargetEvent(record.originalData);
                onOpen();
              }}
            />
            {/* {userDetail?.userType === "ADMIN" && ( 
              <RiDeleteBin6Line
                style={{
                  color: "#ff4d4f",
                  cursor: "pointer",
                  height: "20px",
                  width: "20px",
                }}
                onClick={() => {
                  setTargetEvent(record.originalData);
                  onDeleteOpen();
                }}
              />
            )}*/}
            {record.isFav ? (
              <RiStarFill
                style={{
                  color: "#ffe234",
                  cursor: "pointer",
                  height: "20px",
                  width: "20px",
                }}
                onClick={() => handleFavoriteToggle(record)}
              />
            ) : (
              <RiStarLine
                style={{
                  color: "#ffe234",
                  cursor: "pointer",
                  height: "20px",
                  width: "20px",
                }}
                onClick={() => handleFavoriteToggle(record)}
              />
            )}
          </Space>
        );
      },
    },
  ];

  const handleCasestudy = async (record: any) => {
    console.log("recordrecordrecordrecord", record);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/caseStudy/getById/${record.originalData.titleUrl}`
      );
      console.log("responsesetCasestudyData", response.data);
      setCasestudyData(response.data);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  return (
    <>
      <div
        style={{
          width: "96vw",
          maxWidth: "96vw",
          maxHeight: "86vh",
          height: "86vh",
          top: "8vh ",
          left: "4vw",
          overflowY: "auto",
          position: "relative",
          backgroundColor: "#EEEEEE",
          padding: "30px",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <Flex w="full" alignItems="center" justifyContent="space-between">
            <Box
              display="flex"
              alignItems="center"
              bg="#FFF"
              border="1px solid #b2b2b233"
              borderRadius="12px"
              w="498px"
              padding="8px"
            >
              <Box
                pl={2}
                display="flex"
                alignItems="center"
                color="#9E9E9E"
                fontSize="2xl"
              >
                <img
                  src="/icons/searchlogo.svg"
                  alt="searchlogo"
                  style={{ height: "24px", width: "24px" }}
                />
              </Box>

              <Input
                id="search"
                type="text"
                placeholder="Search or type a command"
                onChange={(e: any) => handleSearch(e.target.value)}
                value={searchQuery}
                fontSize="sm"
                border="none"
                outline="none"
                color="#757575"
                _focus={{
                  border: "none",
                  outline: "none",
                  boxShadow: "none",
                }}
                bg={"transparent"}
                style={{
                  outline: "none",
                  boxShadow: "none",
                }}
              />
            </Box>

            <Spacer />

            <Box marginRight={5}>
              <Select
                defaultValue="All"
                style={{ width: 200 }}
                onChange={(event: any) => handleChange(event)}
                   value={searchText}
                bg="#FFF"
              >
                {categoryNames.map((category) => (
                  <option key={category} value={category}>
                    {category}
                  </option>
                ))}
              </Select>
            </Box>

            <Box
              background="#000"
              fontSize={"sm"}
              color="#fff"
              w="fit-content"
              textAlign="center"
              p={3}
              onClick={() => {
                onOpen();
                setTargetEvent("");
                setCasestudyData("");
              }}
              cursor="pointer"
              borderRadius="8px"
              _hover={{ background: "#000" }}
            >
              + Add Casestudy
            </Box>
          </Flex>

          <Spacer></Spacer>
          <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={filteredData}
            loading={loading}
            rowKey="_id"
            // size="middle"
            scroll={{ x: "max-content" }}
            onChange={handleTableChange}
            style={{
              backgroundColor: "white",
              borderRadius: 6,
            }}
            pagination={{
              current: pagination.current,
              pageSize: pagination.pageSize,
              total: pagination.total,
              // showSizeChanger: true,
              showQuickJumper: true,
              showTotal: (total) =>
                `Showing page ${pagination.current} — approx ${total} items`,
            }}
            locale={{ emptyText: loading ? <Spin /> : "No data" }}
          />

          {/* <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={filteredData}
            scroll={{ x: "max-content" }}
            size="middle"
            style={{
              backgroundColor: "white",
              borderRadius: 6,
            }}
            pagination={{
              position: ["bottomRight"],
              pageSize: 9,
            }}
          /> */}
        </div>
      </div>

      {isOpen && (
        <CasestudyEditDrawer
          isOpen={isOpen}
          onClose={onClose}
          bannerData={targetevent}
          casestudyData={casestudyData}
          refreshData={() => {
            dispatch({
              type: "REQUEST_MASTER_CASESTUDY",
              payload: {
                type: categoryFilter,
              },
              onSuccess: (response: any) => {
                console.log("Fetched casestudy successfully:", response);

                const transformedData = response.data.map(
                  (casestudy: any, index: number) => ({
                    key: casestudy._id,
                    index: index + 1,
                    title: casestudy.title,
                    image: `${process.env.REACT_APP_IMAGE_BASE_URL}/${casestudy.imageURL}`,
                    casestudyId: casestudy.caseStydyId,
                    createdDate: new Date(
                      casestudy.createdAt
                    ).toLocaleDateString(),
                    description: casestudy.description,
                    isFav: casestudy.isFav,
                    originalData: casestudy,
                    subcategory: casestudy.subCategory,
                    type: casestudy.type,
                    url: `https://10turtle.com/work/${casestudy.titleUrl}`,
                  })
                );
                const filtered = searchQuery
                  ? transformedData.filter(search)
                  : transformedData;

                setFilteredData(filtered);
              },
              onError: (error: any) => {
                console.error("Error fetching casestudy:", error);
                toast({
                  title: "Error",
                  description: "Failed to fetch case studies.",
                  status: "error",
                  duration: 3000,
                  isClosable: true,
                  position: "top-right",
                });
              },
            });
          }}
        />
      )}

      {isViewOpen && (
        <CasestudyDetailsModal
          isOpen={isViewOpen}
          onClose={onViewClose}
          restaurantData={targetevent}
        />
      )}

      {isDeleteOpen && targetevent && (
        <CasestudyDeleteConfirmation
          isOpen
          bannerData={targetevent}
          onDeleteClose={onDeleteClose}
          refreshData={() => {
            dispatch({
              type: "REQUEST_MASTER_CASESTUDY",
              payload: {
                type: categoryFilter,
              },
              onSuccess: (response: any) => {
                console.log("Fetched casestudy successfully:", response);

                const transformedData = response.data.map(
                  (casestudy: any, index: number) => ({
                    key: casestudy._id,
                    index: index + 1,
                    title: casestudy.title,
                    image: `${process.env.REACT_APP_IMAGE_BASE_URL}/${casestudy.imageURL}`,
                    casestudyId: casestudy.caseStydyId,
                    createdDate: new Date(
                      casestudy.createdAt
                    ).toLocaleDateString(),
                    description: casestudy.description,
                    originalData: casestudy,
                    subcategory: casestudy.subCategory,
                    type: casestudy.type,
                    url: `https://10turtle.com/work/${casestudy.titleUrl}`,
                  })
                );
                const filtered = searchQuery
                  ? transformedData.filter(search)
                  : transformedData;

                setFilteredData(filtered);
              },
              onError: (error: any) => {
                console.error("Error fetching casestudy:", error);
                toast({
                  title: "Error",
                  description: "Failed to fetch case studies.",
                  status: "error",
                  duration: 3000,
                  isClosable: true,
                  position: "top-right",
                });
              },
            });
          }}
        />
      )}
    </>
  );
};

export default CasestudyTable;
